var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "occupation-view" }, [
    _c(
      "div",
      { staticClass: "occupation-details" },
      [
        _c("MaterialSlideShow", {
          staticClass: "slide_fixed_height",
          attrs: {
            smallNavigation: true,
            slides: _vm.occupationImages,
            imageKey: "url",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-content pt-3" }, [
          _c("div", { staticClass: "occupation-detail-header" }, [
            _c("div", { staticClass: "occupation-info" }, [
              _c("p", { staticClass: "cemetery-name" }, [
                _vm._v(_vm._s(_vm.cemeteryName)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wrapper row flex-column no-gutters" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-sm d-flex" }, [
                      _c("div", { staticClass: "occupation-status-id" }, [
                        _c("h3", { staticClass: "occupation-id" }, [
                          _c("div", { staticClass: "main-title" }, [
                            _c("span", [_vm._v(_vm._s(_vm.occupationCode))]),
                          ]),
                          _vm._v(" "),
                          _vm.occupationState
                            ? _c(
                                "span",
                                { staticClass: "occupation-status vacant" },
                                [
                                  _vm._v(
                                    "\n                                                " +
                                      _vm._s(_vm.occupationState) +
                                      "\n                                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.allowViewDetail
                      ? _c("div", { staticClass: "col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "occupation-view-btn btn btn-outline-secondary-main",
                              attrs: {
                                type: "button",
                                "aria-label": `view ${_vm.occupationName}`,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onViewDetailOccupation.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c("i", {
                                  staticClass:
                                    "far fa-rectangle-list view-icon",
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-icon" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `${_vm.baseTranslateID}.buttons.view`
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "occupation-interments-info" }, [
                    _c("div", { staticClass: "amounts-direction" }, [
                      _vm.totalCapacityText
                        ? _c(
                            "div",
                            {
                              staticClass: "total-capacity item-with-separator",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icon",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "14",
                                    height: "15",
                                    viewBox: "0 0 14 15",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M10.2876 4.11067C10.657 6.33744 8.73615 8.26726 6.44594 7.97036C5.04226 7.74769 3.93409 6.63434 3.71246 5.22405C3.34307 2.99729 5.26389 1.06737 7.48023 1.36427C8.95779 1.51272 10.1398 2.70039 10.2876 4.11067Z",
                                      stroke: "currentColor",
                                      "stroke-opacity": "0.6",
                                      "stroke-width": "1.5",
                                      "stroke-miterlimit": "10",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M1 13.334V11.6673C1 11.4673 1.07059 11.2673 1.28235 11.134C1.91765 10.6006 3.89412 9.33398 7 9.33398C10.1059 9.33398 12.0824 10.6006 12.7176 11.134C12.8588 11.2673 13 11.4673 13 11.6673V13.334C13 13.734 12.7176 14.0007 12.2941 14.0007H1.70588C1.28235 14.0007 1 13.734 1 13.334Z",
                                      stroke: "currentColor",
                                      "stroke-opacity": "0.6",
                                      "stroke-width": "1.5",
                                      "stroke-miterlimit": "10",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "amount" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.totalCapacityText) + " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator" }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.burialsCapacityText
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "burial-capacity item-with-separator",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icon",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M6.06602 15.0003H9.66602C9.99935 15.0003 10.266 14.8003 10.3327 14.4669L11.9993 5.86693C12.1327 5.26693 12.066 4.66693 11.7993 4.13359L10.3993 1.33359C10.266 1.13359 10.066 0.933594 9.79935 0.933594H5.93268C5.66602 1.00026 5.46602 1.13359 5.33268 1.40026L3.93268 4.20026C3.66602 4.73359 3.59935 5.33359 3.73268 5.86693L5.46602 14.4669C5.46602 14.8003 5.79935 15.0003 6.06602 15.0003Z",
                                      stroke: "currentColor",
                                      "stroke-opacity": "0.6",
                                      "stroke-width": "1.5",
                                      "stroke-miterlimit": "10",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M8 4.33398V7.66732M9 5.66732H7",
                                      stroke: "currentColor",
                                      "stroke-opacity": "0.6",
                                      "stroke-width": "1.5",
                                      "stroke-miterlimit": "10",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "amount" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.burialsCapacityText) + " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator" }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cremationCapacityText
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "cremation-capacity item-with-separator",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icon",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M8 1V1.66667M8 1.66667C6.33333 1.66667 5.66667 2.66667 5.66667 2.66667V4.66667M8 1.66667C9.66667 1.66667 10.3333 2.66667 10.3333 2.66667V4.66667M5.66667 4.66667H10.3333M5.66667 4.66667C5.66667 4.66667 3 5 3 8C3 10.5333 5 13.1333 5.53333 13.8C5.6 13.9333 5.66667 14.0667 5.66667 14.2V14.9333H10.3333V14.2C10.3333 14.0667 10.4 13.9333 10.4667 13.8C11.0667 13.1333 13 10.6 13 8C13 5 10.3333 4.66667 10.3333 4.66667",
                                      stroke: "currentColor",
                                      "stroke-opacity": "0.6",
                                      "stroke-width": "1.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "amount" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.cremationCapacityText) + " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator" }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.entombmentCapacityText
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "entombment-capacity item-with-separator",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icon",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1.30469 14H3.42602M14.6933 14H12.5372M3.42602 14V6.45312H1.30469L7.98157 2L14.6933 6.45312H12.5372V14M3.42602 14H6.41049M12.5372 14H9.5266M6.41049 14V8.50609C6.41049 8.50609 6.41049 6.97821 7.98157 6.97821C9.55264 6.97821 9.5266 8.50609 9.5266 8.50609V14M6.41049 14H7.96854H9.5266",
                                      stroke: "currentColor",
                                      "stroke-opacity": "0.6",
                                      "stroke-width": "1.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "amount" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.entombmentCapacityText) + " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator" }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.memorialCapacityText
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "memorial-capacity item-with-separator",
                            },
                            [
                              _c("img", {
                                staticClass: "icon",
                                attrs: {
                                  loading: "lazy",
                                  src: "https://demo.chronicle.rip/assets/images/memorial_urn.svg",
                                  alt: "Image description for memorial_urn",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "amount" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.memorialCapacityText) + " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator" }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.unspecifiedCapacityText
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "unspecified-capacity item-with-separator",
                            },
                            [
                              _c("img", {
                                staticClass: "icon",
                                attrs: {
                                  loading: "lazy",
                                  src: "https://demo.chronicle.rip/assets/images/unspecified_urn.svg",
                                  alt: "Image description for unspecified_urn",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "amount" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.unspecifiedCapacityText) +
                                    " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator" }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.occupationDirectionCode
                        ? _c("div", { staticClass: "item-with-separator" }, [
                            _c(
                              "div",
                              {
                                staticClass: "direction-icon-wrapper",
                                attrs: {
                                  title: _vm.occupationDirectionName,
                                  "data-toggle": "tooltip-city",
                                },
                              },
                              [
                                _c("span", { staticClass: "direction-icon" }, [
                                  _c("i", {
                                    staticClass: "fas",
                                    class: _vm.occupationDirectionClass,
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.occupationDirectionCode)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "separator" }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.occupationType
                        ? _c("div", { staticClass: "item-with-separator" }, [
                            _c("span", [_vm._v(_vm._s(_vm.occupationType))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "separator" }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.occupationPosition
                        ? _c("div", { staticClass: "item-with-separator" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.occupationPosition)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "separator" }),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.occupationInscription
            ? _c("div", { staticClass: "occupation-inscription" }, [
                _c("div", { staticClass: "content" }, [
                  _c("span", [
                    _c(
                      "svg",
                      {
                        staticClass: "icon",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "14",
                          viewBox: "0 0 16 14",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M1.09961 13H14.8989M3.5782 13H12.4203V5.25C12.4203 5.25 12.1748 1 7.99933 1C3.82381 1 3.5782 5.25 3.5782 5.25V13ZM6.10451 4.78939H9.89398V6.68413H6.10451V4.78939Z",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.occupationInscription))]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "occupation-interments" },
            [
              _c(_vm.componentView, {
                tag: "component",
                attrs: {
                  panelCfg: _vm.panelCfg,
                  parentId: _vm.parentId,
                  moduleCode: _vm.moduleCode,
                  additional: _vm.additional,
                  baseTranslateID: _vm.baseTranslateID,
                },
                model: {
                  value: _vm.form,
                  callback: function ($$v) {
                    _vm.form = $$v
                  },
                  expression: "form",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "occupation-actions" }, [
          _c(
            "div",
            { staticClass: "occupation-actions-wrapper" },
            _vm._l(_vm.activeButtons, function (btn) {
              return _c(
                "button",
                {
                  key: `occupation-action-${btn.id}`,
                  class: ["btn", btn.class],
                  attrs: { disabled: !btn.active },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return btn.fn.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "icon", class: btn.icon }),
                  _vm._v(" "),
                  _c("span", { staticClass: "occupation-action-title" }, [
                    _vm._v(_vm._s(_vm.$t(btn.name))),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }